import type { EnrichmentStatus } from '@/lib/recordings/types/attendees';
import { gravatarUrlFor } from './gravatar-url-for';

/**
 * Resolve the best avatar image URL for an attendee, shared by every avatar
 * surface (the attendees panel + the transcript speaker avatar) so they show
 * the same picture.
 *
 * Fallback chain: Apollo `photoUrl` → Gravatar URL (enriched only) → undefined
 * (caller renders initials). For unenriched rows (no_match / failed) a Gravatar
 * 404 is near-certain, so we skip the wasted request and return undefined.
 */
export function resolveAttendeePhotoUrl(attendee: {
  email: string;
  photoUrl?: string | null;
  enrichmentStatus?: EnrichmentStatus;
}): string | undefined {
  if (attendee.photoUrl) return attendee.photoUrl;
  if (attendee.enrichmentStatus === 'enriched') return gravatarUrlFor(attendee.email);
  return undefined;
}
